/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPostNotificationReqBodyDto
 */
export interface AdminPostNotificationReqBodyDto {
    /**
     * 제목
     * @type {string}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'title': string;
    /**
     * 내용
     * @type {string}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'content': string;
    /**
     * 링크
     * @type {string}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'link': string;
    /**
     * 알림 대상 카테고리
     * @type {Array<string>}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'targetCategories': Array<AdminPostNotificationReqBodyDtoTargetCategoriesEnum>;
    /**
     * 알림 전송 카테고리
     * @type {Array<string>}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'sendCategories': Array<AdminPostNotificationReqBodyDtoSendCategoriesEnum>;
    /**
     * 개인 지정 알림시 유저 uuid
     * @type {Array<string>}
     * @memberof AdminPostNotificationReqBodyDto
     */
    'targetIds'?: Array<string>;
}

export const AdminPostNotificationReqBodyDtoTargetCategoriesEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    AllUser: 'allUser',
    EachUser: 'eachUser'
} as const;

export type AdminPostNotificationReqBodyDtoTargetCategoriesEnum = typeof AdminPostNotificationReqBodyDtoTargetCategoriesEnum[keyof typeof AdminPostNotificationReqBodyDtoTargetCategoriesEnum];
export const AdminPostNotificationReqBodyDtoSendCategoriesEnum = {
    Viewup: 'viewup',
    Sms: 'sms'
} as const;

export type AdminPostNotificationReqBodyDtoSendCategoriesEnum = typeof AdminPostNotificationReqBodyDtoSendCategoriesEnum[keyof typeof AdminPostNotificationReqBodyDtoSendCategoriesEnum];


